<template>
  <div class="t-tip">

    <slot name="content">
    </slot>

  </div>
</template>

<script>
export default {
  namde: 'hint',
  props: [ 'isShow' ],
  data() {
    return {
      tipEl: document.querySelector("t-tip")
    }
  },

  mounted () {
    document.addEventListener('mousemove', this.showTooltip, false);
  },

  methods: {

    getClosest(elem, selector) {
      // Element.matches() polyfill
      if (!Element.prototype.matches) {
          Element.prototype.matches =
              Element.prototype.matchesSelector ||
              Element.prototype.mozMatchesSelector ||
              Element.prototype.msMatchesSelector ||
              Element.prototype.oMatchesSelector ||
              Element.prototype.webkitMatchesSelector ||
              function(s) {
                  var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                      i = matches.length;
                  while (--i >= 0 && matches.item(i) !== this) {}
                  return i > -1;
              };
      }

      // Get the closest matching element
      for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
      }
      return null;
    },

    showTooltip(e) {
      // var tooltip = e.target.classList.contains("t-tip")
          // ? e.target
          // : e.target.querySelector(":scope .t-tip");

      let tooltip = this.$el
      let parent = this.getClosest(e.target, '.b-filter')

      if (tooltip && parent && !this.isShow) {
        let rect = parent.getBoundingClientRect()
        let x = e.clientX - rect.left + 10; //x position within the element.
        let y = e.clientY - rect.top + 10;  //y position within the element.

        // console.log('x', x);
        // console.log('y', y);

        tooltip.style.transform = `translate(${x}px, ${y}px)`

        // tooltip.style.left =
        //     (e.pageX + tooltip.clientWidth + 10 < document.body.clientWidth)
        //         ? (e.pageX + 10 + "px")
        //         : (document.body.clientWidth + 5 - tooltip.clientWidth + "px");
        // tooltip.style.top =
        //     (e.pageY + tooltip.clientHeight + 10 < document.body.clientHeight)
        //         ? (e.pageY + 10 + "px")
        //         : (document.body.clientHeight + 5 - tooltip.clientHeight + "px");
      }

    }
  }
}
</script>



<style lang="scss">
  .t-tip{
    position: absolute;
    z-index: 100;
  }

  $popper-background-color: #ff6659 !default;

  .vue-tooltip {
    background-color: $popper-background-color;
    box-sizing: border-box;
    // color: #181818;
    color: #fff;
    // min-width: 120px;
    max-width: 320px;
    padding: 6px 10px;
    border-radius: 3px;
    z-index: 100;
    box-shadow: 2px 2px 3px rgba(#000, 0.25);

    .button{
      border-color: #fff;
      margin-top: 1em;
      color: #fff;
    }

    .vue-tooltip-content {
      text-align: center;
    }

    // .popper-close {
    //  position: absolute;
    //  top: 2px;
    //  right: 4px;
    //  color: black;
    //  background: transparent;
    //  border: none;

    //  &:active,
    //  &:focus {
    //      outline: none;
    //  }
    // }

    .tooltip-arrow {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-top-color: $popper-background-color;
        border-bottom-color: transparent !important;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        bottom: -5px;
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-bottom-color: $popper-background-color;
        border-top-color: transparent !important;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        top: -5px;
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-right-color: $popper-background-color;
        border-top-color: transparent !important;
        border-left-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-left-color: $popper-background-color;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hint.vue